import { render, staticRenderFns } from "./Artists.vue?vue&type=template&id=34fe7bed&scoped=true&"
import script from "./Artists.vue?vue&type=script&lang=js&"
export * from "./Artists.vue?vue&type=script&lang=js&"
import style0 from "./Artists.vue?vue&type=style&index=0&id=34fe7bed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34fe7bed",
  null
  
)

export default component.exports